var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnicianMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C9 0 0 9 0 20C0 31 9 40 20 48C31 40 40 31 40 20C40 9 31 0 20 0Z",
    fill: "#F38A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicianMarker);
export default __webpack_public_path__ + "static/media/technician-marker.f0e04f10721bdbb9e8ee203d89b09b4f.svg";
export { ForwardRef as ReactComponent };